/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiMatchResponse } from '../models/AiMatchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiMatchingService {
    /**
     * Generate Match
     * @returns AiMatchResponse Successful Response
     * @throws ApiError
     */
    public static generateMatchApiAiMatchingGeneratePost(): CancelablePromise<AiMatchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ai-matching/generate',
        });
    }
}
